// extracted by mini-css-extract-plugin
module.exports = {"item":"SkipToContentLink__item--2KtoZ"};